import angular from 'angular';
import angularSvgRoundProgressBar from 'angular-svg-round-progressbar';
import 'angularjs-datepicker';

import './index.scss';

import filterModule from './filters';
import formModule from './form';
import formattingModule from './formatting';
import layoutModule from './layout';
import progressCheckmarkModule from './progress-checkmark';
import twoPartAllocationBarModule from './two-part-allocation-bar';
import translationsModule from './translations';
import signaturePad from './signature-pad';
import cardLoadingIndicator from './card-loading-indicator';
import expander from './expander';
import carousel from './carousel';
import multipleInput from './multiple-input';
import wsStepper from './stepper';
import utils from './utils';

const injectorName = 'ws.common';
export default injectorName;

angular.module(injectorName, [
  'ngAnimate',
  'ngSanitize',
  'ngAria',
  'pascalprecht.translate',
  '720kb.datepicker',
  angularSvgRoundProgressBar,
  translationsModule,
  filterModule,
  formModule,
  formattingModule,
  layoutModule,
  progressCheckmarkModule,
  twoPartAllocationBarModule,
  signaturePad,
  cardLoadingIndicator,
  expander,
  carousel,
  multipleInput,
  wsStepper,
  utils,
])
.config(WsCommonModuleConfig);

WsCommonModuleConfig.$inject = ['$translateProvider'];
function WsCommonModuleConfig($translateProvider) {
  $translateProvider.preferredLanguage('en_CA');
  $translateProvider.useSanitizeValueStrategy('escapeParameters');
}



// WEBPACK FOOTER //
// ./src/index.js